// import { createApp } from 'vue'
import Vue from 'vue';
import Preisrechner from './App.vue'
import Bestellstrecke from './Bestellstrecke.vue'
import popover from "@/directives/popover";
import PriceHistory from "@/components/PriceHistory.vue";

// createApp(App).mount('#preisrechner')


// const app = createApp(App)
// app.config.globalProperties.init_swiper = window.init_swiper;
Vue.prototype.init_swiper = window.init_swiper;
Vue.prototype.$headroom = window.headroom;
// app.mount('#preisrechner')

Vue.config.productionTip = false

Vue.directive('popover', popover)

const preisrechner = document.getElementById('preisrechner');
if (preisrechner) {
  new Vue({
    render: h => h(Preisrechner),
  }).$mount(preisrechner);
}

const bestellstrecke = document.getElementById('bestellstrecke');
if (bestellstrecke) {
  const settingsEL = document.getElementById('settings');
  const settings = settingsEL ? JSON.parse(settingsEL.innerHTML) : {};
  new Vue({
    render: h => h(Bestellstrecke),
    provide: {settings},
  }).$mount(bestellstrecke);
}

const pricehistory = document.querySelectorAll('[data-component="PriceHistory"]')
pricehistory.forEach(el => {
  let props = {}
  if (el.dataset.props) {
    try { props = JSON.parse(el.dataset.props); } catch (e) { console.error(e); }
  }
  new Vue({
    render: h => h(PriceHistory, {props}),
  }).$mount(el)
})
